import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './manage_cf.less'
import { Link, withRouter } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import FlatProgress from 'components/common/flat_progress'
import NoCurrencyAlert from 'components/pages/campaign/no_currency_alert'
import { Button } from '@paypalcorp/pp-react'
import CampaignBalance from 'components/pages/campaign/campaign_balance'
import CrowdfundingActivity from 'components/glimpses/edit_glimpse/activity/crowdfunding_activity'
import CrowdfundingHeader from 'components/crowdfunding_campaign_header'

const i18n = getI18n('components/edit_glimpse/manage_cf')

class Manage extends React.Component {
  static propTypes = {
    hasChippedIn: PropTypes.bool,
    hasMoneybox: PropTypes.bool,
    currencyCode: PropTypes.string,
    campaignId: PropTypes.string,
    dispatch: PropTypes.func,
    hasCurrencyBalance: PropTypes.bool,
    onTransfer: PropTypes.func,
    currentValue: PropTypes.number,
    goal: PropTypes.number,
  }

  handleTransferClick = event => {
    if (!this.props.hasMoneybox) {
      event.preventDefault()
    } else {
      this.props.onTransfer()
    }
  }

  render() {
    const {
      hasCurrencyBalance,
      currencyCode,
      campaignId,
      hasChippedIn,
      hasMoneybox,
      currentValue,
      goal,
    } = this.props

    return (
      <div>
        {!hasCurrencyBalance && <NoCurrencyAlert currency={currencyCode} />}
        <div styleName="text-center">
          <div styleName="pool-header">
            <CrowdfundingHeader campaignId={campaignId} />
          </div>

          <FlatProgress
            goalAmount={goal}
            totalAmount={currentValue}
            currencyCode={currencyCode}
          />

          {hasChippedIn && (
            <Button
              secondary
              styleName="btn"
              disabled={!hasMoneybox}
              data-nemo="transfer-menu-button"
              onClick={this.handleTransferClick}
            >
              {i18n('transfer_link')}
            </Button>
          )}

          <Link
            to={glimpseRoute('edit')}
            styleName="edit-link"
            data-nemo="editPool"
          >
            {i18n('edit_pool')}
          </Link>
        </div>

        <CampaignBalance campaignId={campaignId} />

        <CrowdfundingActivity campaignId={campaignId} />
      </div>
    )
  }
}

export default withRouter(cssModules(Manage, styles))
